import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Badge,
  List,
  ListItem,
  Divider,
} from '@chakra-ui/react';
import { FaCheckCircle, FaTrophy, FaMagic, FaLightbulb, FaExclamationTriangle, FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const QuickHelpContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <VStack spacing={3} align="stretch" maxW="100%">
      {/* Objectif du jeu */}
      <Box bg="rgba(139, 148, 179, 0.1)" borderRadius="md" p={3}>
        <HStack mb={2}>
          <FaTrophy color="var(--jaune-vif)" />
          <Text fontSize="sm" fontWeight="bold" color="var(--texte-clair)">
            {t('help.objective.title')}
          </Text>
        </HStack>
        <Text fontSize="xs" color="var(--texte-clair)" opacity={0.9}>
          {t('help.objective.description')}
        </Text>
      </Box>

      {/* Comment gagner */}
      <Box bg="rgba(139, 148, 179, 0.1)" borderRadius="md" p={3}>
        <HStack mb={2}>
          <FaStar color="var(--jaune-vif)" />
          <Text fontSize="sm" fontWeight="bold" color="var(--texte-clair)">
            {t('help.howToWin.title')}
          </Text>
        </HStack>
        <List spacing={1} fontSize="xs">
          <ListItem color="var(--texte-clair)" opacity={0.9}>
            • {t('help.howToWin.step1')}
          </ListItem>
          <ListItem color="var(--texte-clair)" opacity={0.9}>
            • {t('help.howToWin.step2')}
          </ListItem>
          <ListItem color="var(--texte-clair)" opacity={0.9}>
            • {t('help.howToWin.step3')}
          </ListItem>
        </List>
      </Box>

      {/* Règles importantes - SECTION MISE EN AVANT */}
      <Box bg="rgba(255, 69, 0, 0.15)" borderRadius="md" p={3} border="1px solid rgba(255, 69, 0, 0.3)">
        <HStack mb={2}>
          <FaExclamationTriangle color="var(--orange-vif)" />
          <Text fontSize="sm" fontWeight="bold" color="var(--texte-clair)">
            {t('help.important.title')}
          </Text>
        </HStack>
        <List spacing={1} fontSize="xs">
          <ListItem color="var(--texte-clair)" opacity={0.95} fontWeight="bold">
            • {t('help.important.rule1')}
          </ListItem>
          <ListItem color="var(--texte-clair)" opacity={0.9}>
            • {t('help.important.rule2')}
          </ListItem>
          <ListItem color="var(--texte-clair)" opacity={0.9}>
            • {t('help.important.rule3')}
          </ListItem>
          <ListItem color="var(--texte-clair)" opacity={0.9}>
            • {t('help.important.rule4')}
          </ListItem>
        </List>
      </Box>

      {/* Difficulté */}
      <Box bg="rgba(139, 148, 179, 0.1)" borderRadius="md" p={3}>
        <HStack mb={2}>
          <FaLightbulb color="var(--orange-vif)" />
          <Text fontSize="sm" fontWeight="bold" color="var(--texte-clair)">
            {t('help.difficulty.title')}
          </Text>
        </HStack>
        <Text fontSize="xs" color="var(--texte-clair)" opacity={0.9} mb={2}>
          {t('help.difficulty.description')}
        </Text>
        <HStack spacing={2} flexWrap="wrap">
          <Badge colorScheme="green" fontSize="xs">{t('help.difficulty.easy')}</Badge>
          <Badge colorScheme="orange" fontSize="xs">{t('help.difficulty.medium')}</Badge>
          <Badge colorScheme="red" fontSize="xs">{t('help.difficulty.hard')}</Badge>
        </HStack>
      </Box>

      {/* Catégorie Mystère */}
      <Box bg="rgba(139, 148, 179, 0.1)" borderRadius="md" p={3}>
        <HStack mb={2}>
          <FaMagic color="var(--magenta-vif)" />
          <Text fontSize="sm" fontWeight="bold" color="var(--texte-clair)">
            {t('help.mystery.title')}
          </Text>
        </HStack>
        <Text fontSize="xs" color="var(--texte-clair)" opacity={0.9}>
          {t('help.mystery.description')}
        </Text>
      </Box>
    </VStack>
  );
};

export default QuickHelpContent;
